import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/joy';
import AppBar from './AppBar';

/**
 * MainLayout component that wraps all protected routes
 * Includes AppBar at the top (which contains both the navigation drawer and user menu)
 */
export default function MainLayout({ children }) {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
      <AppBar />
      <Box sx={{ pt: '64px' }}>
        {children}
      </Box>
    </Box>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

